import { render, staticRenderFns } from "./EditCafeteriaPage.vue?vue&type=template&id=3ff44ce2"
import script from "./EditCafeteriaPage.vue?vue&type=script&lang=js"
export * from "./EditCafeteriaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports